import { EnrollmentContent } from "../../components/app";

export default function Enrollment() {
  return (
    <>
      <EnrollmentContent />
    </>
  );
}
